import { getSettingsEditing } from 'client/reducers/managementReducer'
import { useManagement } from 'client/store'
import React, { useMemo } from 'react'
import {
  FormCheckboxInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { BaseEditorCheckbox } from '../base-editor-checkbox'
import { FormBaseSubentity } from './form-base-subentity'
import { useUpdateFormSubentityProps } from './hooks/use-update-form-subentity-prop'

interface FormCheckboxSubentityProps {
  formEntity: FormInterface
  checkboxSubentity: FormCheckboxInterface
}

export const FormCheckboxSubentity = ({
  formEntity,
  checkboxSubentity,
}: FormCheckboxSubentityProps) => {
  const entity = useMemo(
    () => ({
      ...checkboxSubentity,
      ...formEntity.checkboxesCommonStyles,
    }),
    [checkboxSubentity, formEntity.checkboxesCommonStyles],
  )

  const editingFormSubentityId = useManagement(getSettingsEditing).subentityId

  const updateProps = useUpdateFormSubentityProps(formEntity, checkboxSubentity)
  return (
    <FormBaseSubentity
      formEntity={formEntity}
      subentity={checkboxSubentity}
      title={'entity_settings.checkbox.header'}
    >
      <BaseEditorCheckbox
        entityOrSubEntity={entity}
        isEditing={editingFormSubentityId === checkboxSubentity.id}
        checked={false}
        // biome-ignore lint/suspicious/noEmptyBlockStatements: <explanation>
        onChange={() => {}}
        updateText={updateProps}
      />
    </FormBaseSubentity>
  )
}
